module.exports = __webpack_public_path__ + "static/fr-logo100-web-ad214f69a88b920b564ff2917756ed66.svg";